import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikFormComponent } from 'formik';
import { focusFirstElement } from '../../../common/utils';

class FormikFormElementController extends React.Component {
  constructor() {
    super();
    this.refFormWrapper = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const {
      props: {
        isFormDirty,
        handleDirtyForm,
        formSubmission:
          {
            isSubmitting,
            errors
          }
      },
      refFormWrapper: {
        current: formWrapperDom
      }
    } = this;

    if (handleDirtyForm) {
      handleDirtyForm(isFormDirty);
    }

    const isFormInvalid = Object.keys(errors).length > 0;
    if (prevProps && prevProps.formSubmission.isSubmitting && !isSubmitting && isFormInvalid && isFormDirty) {
      focusFirstElement(formWrapperDom, ['[aria-invalid="true"]']);
    }
  }

  render() {
    const {
      props: {
        formElementAttributes,
        children
      },
      refFormWrapper
    } = this;

    return (
      <div className='form-wrap' ref={refFormWrapper}>
        <FormikFormComponent {...formElementAttributes}>
          {children}
        </FormikFormComponent>
      </div>
    );
  }
}

FormikFormElementController.propTypes = {
  isFormDirty: PropTypes.bool.isRequired,
  formSubmission: PropTypes.shape({
    isSubmitting: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired
  }).isRequired,
  handleDirtyForm: PropTypes.func,
  formElementAttributes: PropTypes.shape({ className: PropTypes.string })
};

export default FormikFormElementController;